import { GEN_GRN_INVOICE, GEN_ORD_INVOICE, GEN_PO_INVOICE, HANDLE_SEND } from "./ApiRoutes";
import { authData, multipartDataWithToken } from "./services";

export const gen_ord_invoice = async (orderId: string, response_type: object) =>{
    const response = await authData.get(`${GEN_ORD_INVOICE}/${orderId}`, response_type);
      return response.data;
}

export const handle_send = async (payload: object) => {
   const response =  multipartDataWithToken.post(HANDLE_SEND, payload);
return response;    
}


export const gen_po_invoice = async (orderId: string,response_type: object) =>{
    const response = await authData.get(`${GEN_PO_INVOICE}/${orderId}`, response_type);
      return response.data;
}

export const gen_grn_invoice = async (orderId: string,version: string, response_type:object) =>{
    const response = await authData.get(`${GEN_GRN_INVOICE}/${orderId}/${version}`, response_type);
      return response.data;
}